import axios from 'axios';

import { parseOrganizationYearPlannerActivityTemplateForFE } from 'config/api/yearPlannerActivities/yearPlannerActivities.parsers';
import {
  OrganizationYearPlannerActivityTemplate,
  OrganizationYearPlannerActivityTemplateDTO,
  OrganizationYearPlannerActivityTemplateInput,
} from 'config/api/yearPlannerActivities/yearPlannerActivities.types';
import { Id } from 'types/Id';

const endpoint = 'api/v1/organization_year_planner_activity_templates/';

const organizationYearPlannerActivityTemplatesApi = {
  getAll: async (): Promise<OrganizationYearPlannerActivityTemplate[]> => {
    const { data } = await axios.get<OrganizationYearPlannerActivityTemplateDTO[]>(endpoint);
    return data.map(parseOrganizationYearPlannerActivityTemplateForFE);
  },
  create: async (payload: OrganizationYearPlannerActivityTemplateInput): Promise<OrganizationYearPlannerActivityTemplate> => {
    const { data } = await axios.post<OrganizationYearPlannerActivityTemplateDTO>(endpoint, payload);
    return parseOrganizationYearPlannerActivityTemplateForFE(data);
  },
  update: async ({
    id,
    payload,
  }: {
    id: Id;
    payload: OrganizationYearPlannerActivityTemplateInput;
  }): Promise<OrganizationYearPlannerActivityTemplate> => {
    const { data } = await axios.patch<OrganizationYearPlannerActivityTemplateDTO>(`${endpoint}${id}/`, payload);
    return parseOrganizationYearPlannerActivityTemplateForFE(data);
  },
  remove: async (id: Id): Promise<void> => {
    await axios.delete(`${endpoint}${id}/`);
  },
};

export default organizationYearPlannerActivityTemplatesApi;
